export const tasks = {
    'CLICK_PER_SEC': {
        name: 'Clicks per second',
        range: [
            {
                number: 1,
                reward: {
                    alienId: 1,
                    alienNum: 1
                }
            },
            {
                number: 2,
                reward: {
                    alienId: 1,
                    alienNum: 3
                }
            },
            {
                number: 3,
                reward: {
                    alienId: 1,
                    alienNum: 6
                }
            },
            {
                number: 4,
                reward: {
                    alienId: 1,
                    alienNum: 10
                }
            },]
    },
    'CLICK_PER_MIN': {
        name: 'Clicks per minute',
        range: [
            {
                number: 10,
                reward: {
                    alienId: 1,
                    alienNum: 1
                }
            },
            {
                number: 20,
                reward: {
                    alienId: 1,
                    alienNum: 3
                }
            },
            {
                number: 30,
                reward: {
                    alienId: 1,
                    alienNum: 6
                }
            },
            {
                number: 40,
                reward: {
                    alienId: 1,
                    alienNum: 10
                }
            },
        ]
    },
    'CLICKS_ALL': {
        name: 'All Clicks',
        range: [
            {
                number: 1,
                reward: {
                    alienId: 1,
                    alienNum: 1
                }
            },

        ]

    },
}
export const clickDelay = 500
export const boostDuration = 20000
export const aliensTypes2 = [15000, 10000, 5000, 2500, 1000, 700, 500, 100, 50, 20, 5, 1]
export const aliensTypes = [
    { id: 1, name: 'Just Jelly', imgSrc: 'alien1', price: 25, baseEarn: 1 },
    { id: 2, name: 'Happy Jelly', imgSrc: 'alien2', price: 200, baseEarn: 5 },
    { id: 3, name: 'Crying Jelly', imgSrc: 'alien3', price: 5000, baseEarn: 100 },
    { id: 4, name: 'Wimpy Jelly', imgSrc: 'alien4', price: 50000, baseEarn: 250 },
    { id: 5, name: 'Jolly Jelly', imgSrc: 'alien5', price: 100000, baseEarn: 500 },
    { id: 6, name: 'Grumpy Jelly', imgSrc: 'alien6', price: 350000, baseEarn: 750 },
    { id: 7, name: 'Lovely Jelly', imgSrc: 'alien7', price: 1000000, baseEarn: 1000 },
    { id: 8, name: 'Goofy Jelly', imgSrc: 'alien8', price: 2500000, baseEarn: 1250 },
    { id: 9, name: 'Snarky Jelly', imgSrc: 'alien9', price: 10000000, baseEarn: 2000 },
    { id: 10, minGalaxyInd: 20, name: 'Laughy Jelly', imgSrc: 'alien10', price: 50000000, baseEarn: 5000 },
    { id: 11, minGalaxyInd: 25, name: 'Amazed Jelly', imgSrc: 'alien11', price: 1000000000, baseEarn: 10000 },
    { id: 12, minGalaxyInd: 30, name: 'Sleepy Jelly', imgSrc: 'alien12', price: 5000000000, baseEarn: 15000 },
]

export const shipTypes = [
    { id: 1, color: 'blue', price: 0, baseClickEarn: 1 },
    { id: 2, color: 'red', price: 1000, baseClickEarn: 5 },
    { id: 3, color: 'black', price: 10000, baseClickEarn: 10 },
    { id: 4, color: 'yellow', price: 100000, baseClickEarn: 100 },
    { id: 5, color: 'pink', price: 1000000, baseClickEarn: 500 },
    { id: 6, color: 'purple', price: 10000000, baseClickEarn: 1000 },
]
export const upgrades = {
    ships: {
        name: 'Ship upgrade',
        description: 'Improve your ship to receive more light years for each SpaceBarShip click',
        values: [1, 10, 100, 500, 1000, 5000],
        basePrice: { pinkC: 10, blackC: 1 },
        imgType: null
    },
    aliensDiscount: {
        name: 'Aliens discount',
        description: 'Buying more aliens will cost [value]% less',
        values: [0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50],
        basePrice: { pinkC: 5, blackC: 1 },
        imgType: '%'
    },
    extraBoost: {
        name: 'Boost boost',
        description: 'Boost will give x[value] more light years',
        values: [2, 5, 7, 10],
        basePrice: { pinkC: 0, blackC: 5 },
        imgType: 'x'
    },
    alienBoost: {
        name: 'Aliens boost',
        description: 'All earnings of the alien will be multiplied',
        values: [1, 2, 3, 5, 10, 100],
        aliens: [1, 4, 6, 8, 12],
        basePrice: { pinkC: 3, blackC: 1 },
        imgType: 'x'
    },

}
// pinkC: Math.ceil(5 + (3 * (storage.GALAXY_IND - 1))),
// blackC: Math.ceil(1 + (2 * (storage.GALAXY_IND - 1))),
export const achievements = {
    "Just Jelly": {
        description: "Acquire [value] Just Jellies",
        imgUrl: 'aliens/alien1.png',
        values: [100, 1000],
        award: [{ pinkC: 5, blackC: 1 }, { pinkC: 15, blackC: 5 }]
    },
    "Grumpy Jelly": {
        description: "Acquire [value] Grumpy Jellis",
        imgUrl: 'aliens/alien6.png',
        values: [100, 1000],
        award: [{ pinkC: 7, blackC: 2 }, { pinkC: 20, blackC: 6 }]
    },
    "Lovely Jelly": {
        description: "Acquire [value] Lovely Jellies",
        imgUrl: 'aliens/alien7.png',
        values: [100, 1000],
        award: [{ pinkC: 10, blackC: 3 }, { pinkC: 30, blackC: 7 }]
    },
    "Amazed Jelly": {
        description: "Acquire [value] Amazed Jellies",
        imgUrl: 'aliens/alien11.png',
        values: [10, 100],
        award: [{ pinkC: 15, blackC: 4 }, { pinkC: 50, blackC: 8 }]
    },
    "Sleepy Jelly": {
        description: "Acquire [value] Sleepy Jellies",
        imgUrl: 'aliens/alien12.png',
        values: [10, 100],
        award: [{ pinkC: 20, blackC: 5 }, { pinkC: 100, blackC: 10 }]
    },
    "RICHNESS": {
        description: "Collect [value] light years",
        imgUrl: 'balls/ball_8.png',
        values: [1000000n, 1000000000n, 1000000000000n, 1000000000000000n, 1000000000000000000n],
        award: [{ pinkC: 1, blackC: 0 }, { pinkC: 3, blackC: 1 }, { pinkC: 5, blackC: 2 }, { pinkC: 7, blackC: 3 }, { pinkC: 10, blackC: 5 }]
    },
    "CLICKS_ALL": {
        description: "Click / press on your SpaceBar Ship [value] times",
        imgUrl: 'awards/award_2.png',
        values: [100, 1000, 5000, 10000, 1000000],
        award: [{ pinkC: 3, blackC: 1 }, { pinkC: 5, blackC: 5 }, { pinkC: 20, blackC: 15 }, { pinkC: 100, blackC: 25 }, { pinkC: 1000, blackC: 50 }]
    },
    "MAXED_SPEED": {
        description: "Speed up to the planet [value] times",
        imgUrl: 'awards/award_4.png',
        values: [10, 500, 1000, 5000, 10000],
        award: [{ pinkC: 1, blackC: 1 }, { pinkC: 10, blackC: 1 }, { pinkC: 15, blackC: 2 }, { pinkC: 50, blackC: 3 }]
    }
}
export const galaxies = [
    { name: "Milky Way Galaxy", distance: 0, audioUrl: 'galaxy.mp3' },
    { name: "Helix", distance: 700000, audioUrl: 'galaxy.mp3' },
    { name: "Owl", distance: 2000000, audioUrl: 'spaceship2.mp3' },
    { name: "Ursa Major II Dwarf Galaxy", distance: 5300000, audioUrl: 'spaceship2.mp3' },
    { name: "Cat's Eye", distance: 13000000, audioUrl: 'betrayal.mp3' },

    { name: "Eskimo", distance: 50000000, audioUrl: 'betrayal.mp3' },
    { name: "Trifid", distance: 62000000, audioUrl: 'beyond.mp3' },
    { name: "Spirograph", distance: 75000000, audioUrl: 'beyond.mp3' },
    { name: "Andromeda II Dwarf Galaxy", distance: 100000000, audioUrl: 'city.mp3' },
    { name: "Black Eye", distance: 240000000, audioUrl: 'city.mp3' },

    { name: "Triangulum", distance: 300000000, audioUrl: 'dangerous.mp3' },
    { name: "Lagoon", distance: 400000000, audioUrl: 'dangerous.mp3' },
    { name: "Bode's", distance: 800000000, audioUrl: 'colossal.mp3' },
    { name: "Southern Pinwheel", distance: 1000000000, audioUrl: 'colossal.mp3' },
    { name: "Cigar", distance: 1200000000, audioUrl: 'extreme.mp3' },

    { name: "Andromeda", distance: 2500000000, audioUrl: 'extreme.mp3' },
    { name: "Antennae", distance: 5900000000, audioUrl: 'grey.mp3' },
    { name: "Hourglass", distance: 8000000000, audioUrl: 'grey.mp3' },
    { name: "Whirlpool", distance: 13000000000, audioUrl: 'mobeus.mp3' },
    { name: "Leo I Galaxy", award: [{ 'alien': 10 }], distance: 22000000000, audioUrl: 'mobeus.mp3' },

    { name: "Mice", distance: 30000000000, audioUrl: 'outer.mp3' },
    { name: "Siamese Twins", distance: 40000000000, audioUrl: 'outer.mp3' },
    { name: "Sunflower", distance: 80000000000, audioUrl: 'cosmic.mp3' },
    { name: "Messier 87", distance: 100000000000, audioUrl: 'cosmic.mp3' },
    { name: "Dumbbell", award: [{ 'alien': 11 }], distance: 130000000000, audioUrl: 'dead.mp3' },

    { name: "Northern Pinwheel", distance: 256000000000, audioUrl: 'dead.mp3' },
    { name: "Centaurus A", distance: 310000000000, audioUrl: 'lawless.mp3' },
    { name: "Hoag's Object", distance: 600000000000, audioUrl: 'lawless.mp3' },
    { name: "Tadpole", distance: 820000000000, audioUrl: 'omega.mp3' },
    { name: "Mayall's Object", award: [{ 'alien': 12 }], distance: 1000000000000, audioUrl: 'omega.mp3' },

    { name: "Cartwheel", distance: 500000000000000, audioUrl: 'rising.mp3' },
    { name: "Ghost Head", distance: 2000000000000000, audioUrl: 'radiant.mp3' }
];

export const shipsTypes2 = {
    'spacebar': { id: 15, imgUrl: null, type: 'default' },
    'stick': { id: 1, imgUrl: 'stick.png', marginTop: '0px' },
    'banana': { id: 2, imgUrl: 'banana.png', marginTop: '-6px' },
    'bar': { id: 3, imgUrl: 'bar.png', marginTop: '120px', marginLeft: '13px' },
    'beans': { id: 4, imgUrl: 'beans.png', marginTop: '-23px' },
    'bottle': { id: 5, imgUrl: 'bottle.png', marginTop: '0px' },
    'bread': { id: 6, imgUrl: 'bread.png', marginTop: '65px' },
    'chocolate': { id: 7, imgUrl: 'chocolate.png', marginTop: '0px' },
    'cookie': { id: 8, imgUrl: 'cookie.png', marginTop: '135px' },
    'wine': { id: 9, imgUrl: 'wine.png', marginTop: '0px' },
    'corn': { id: 10, imgUrl: 'corn.png', marginTop: '0px' },
    'flipflop': { id: 11, imgUrl: 'flipflop.png', marginTop: '0px' },
    'hotdog': { id: 12, imgUrl: 'hotdog.png', marginTop: '70px' },
    'sandwich': { id: 13, imgUrl: 'sandwich.png', marginTop: '90px' },
    'wood': { id: 14, imgUrl: 'wood.png', marginTop: '-40px', marginLeft: '28px' }
}

export const shipLevels = [0, 250, 1000, 1500, 3000, 5000, 7000, 9000, 10000, 15000, 20000, 25000, 30000, 50000, 100000]
// export const shipLevels = [0, 2, 5, 10, 15, 50, 70, 90, 100, 150, 200, 250, 300, 350, 400]